import Vue from 'vue'
import Router from 'vue-router'
import Index from 'pages/index/'
import NewsCenter from 'pages/newsCenter/newsCenter'
import NewsPage from 'pages/newsPage/newsPage'
import AnnounceCenter from 'pages/announceCenter/announceCenter'
import AnnouncePage from 'pages/announcePage/announcePage'
import JobPage from 'pages/jobPage/jobPage'
import Certificate from 'pages/certificate/certificate'
import License from 'pages/license/license'
import Register from 'pages/license/register'
import DeviceLicense from 'pages/deviceLicense/deviceLicense'
import MerchantEntry from 'pages/merchantEntry/merchantEntry'
import Product from 'pages/product/product'
import PersonCenter from 'pages/personCenter/index'

Vue.use(Router)

// 开启debug模式
Vue.config.debug = true
const router = new Router({
  routes: [{
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/newsCenter',
    name: 'NewsCenter',
    component: NewsCenter,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/newsCenter/newsPage',
    name: 'NewsPage',
    component: NewsPage,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/announceCenter',
    name: 'AnnounceCenter',
    component: AnnounceCenter,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/announceCenter/announcePage',
    name: 'AnnouncePage',
    component: AnnouncePage,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/jobPage',
    name: 'JobPage',
    component: JobPage,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/certificate',
    name: 'Certificate',
    component: Certificate,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/license',
    name: 'License',
    component: License
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/device/license',
    name: 'deviceLicense',
    component: DeviceLicense
  },
  {
    path: '/merchantEntry',
    name: 'merchantEntry',
    component: MerchantEntry
  },
  {
    path: '/product',
    name: 'product',
    component: Product
  },{
    path: '/personCenter',
    name: 'personCenter',
    component: PersonCenter,
    meta: {
      keepAlive: false
    }
  },
  ]
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js